<div class="filterPage__header" *ngIf="(filters$ | async)?.length || 0">
  <h2 class="headingS overlay__focus">{{ FILTER_HEADER }}</h2>
</div>

<form class="filter" [formGroup]="form!">
  <div class="filter__field">
    <app-resetform
      [buttonStyle]="'button button--native-link'"
      (resetFilter)="onResetFilter()"
    ></app-resetform>
  </div>

  <app-filter
    *ngFor="let filter of filters$ | async"
    [form]="form"
    [filter]="filter"
    [id]="filter.name"
    class="filter__field"
  >
  </app-filter>
</form>

<app-show-results id="filterSibling" [items]="items$"></app-show-results>
